<template>
  <div class="home-container">
    <div class='sc-tops' :style="{height:limitDesc===''?'3rem':'4.5rem'}">
      <div class='top-center-count' v-if="canReceive!==-1">
        <span class="count-tip">本日剩余卡券 <span class="highlight">{{canReceive}}</span> 张</span>
      </div>
      <div class='top-center'>
        <div class="list-img">
          <img :src="data.logo">
        </div>
        <div class="list-info">
          <span>{{ data.storeName }}</span>
          <span>满{{ data.amount }}.10元可用</span>
          <span>
            {{ data.address }}
          </span>
        </div>
      </div>
      <div style="background: rgb(255, 255, 255);width: 93%; margin: 0px auto;position: relative;height: 2.3rem;">
        <div class="sc-step">
          <img src="../../assets/img/sclq.png">
          <img src="../../assets/img/scjh.png">
          <img src="../../assets/img/scmd.png">
          <img style="margin-right: 0;" src="../../assets/img/scfkm.png">
        </div>
        <div class="sc-step-loop">
          <span></span>
        </div>
        <div
          style="    position: relative;
    top: 1.55rem;font-size: 0.32rem;display: flex;justify-content: space-evenly;/* position: absolute; *//* margin-top: 1rem; */position: relative;top: 1.55rem;text-align: center;">
          <span style="width: 25%;">领券</span>
          <span style="width: 25%;"> 激活 </span>
          <span style="width: 25%;">线下消费</span>
          <span style="width: 25%;">微信付款码</span>
        </div>

      </div>
      <div class="sc-text" style="margin: 0 auto;color: #000000;padding-left: 0.9rem; display: flex; flex-direction: column;">
       <span> 温馨提示：</span>
       <span> 同一实名微信人每月激活2张代金券</span>
        <span>{{limitDesc}}</span>
      </div>
    </div>
    <!-- <div class="sc-text">
      温馨提示:同一微信号每月限领取一张代金券。
    </div> -->

    <div class="sc-text" style="margin-top: 4rem;margin-bottom: 0.8rem;" >
<!--      <van-notice-bar-->
<!--        v-if="canReceive!==-1"-->
<!--        color="#fff"-->
<!--        left-icon="volume"-->
<!--        :text="limitDesc"-->
<!--      />-->
      <div v-html="data.content"></div>

    </div>
    <div v-show="!islogin" class="sc-button" @click="clickdetial" :class="{ 'disabled': loading }" :style="{ opacity: loading ? 0.6 : 1, pointerEvents: loading ? 'none' : 'auto' }">
      {{ loading ? '处理中...' : '立即开通沃·生活会员(10元/月)' }}
    </div>
    <div v-show="islogin && canReceive!==0"  class="sc-button" @click="clickdetial" :class="{ 'disabled': loading }" :style="{ opacity: loading ? 0.6 : 1, pointerEvents: loading ? 'none' : 'auto' }">
      {{ loading ? '领取中...' : '立即领取' }}
    </div>
  </div>
</template>

<script>
import {
  getReceiveCoupon,
  getCouponInfo,
  getuserInfo
} from '@/api/user'
import {
  Dialog
} from 'vant';
import {
  mapState
} from 'vuex'
import {
  getItem,
  setItem
} from '@/utils/storage'

export default {
  name: 'home',

  props: {},
  data() {
    return {

      active: 0, //被激活的列表
      channels: [], //频道列表
      userType: '',
      isChannelEditShow: false, //频道编辑层
      navlist: [{
        name: '未使用'
      },
      {
        name: '已使用'
      },
      {
        name: '已失效'
      }

      ],
      list: [],
      loading: false,
      detailid: '',
      couponBatchId: '', //券批次id
      data: {},
      finished: false,
      refreshing: false,
      islogin: false, //判断用户是否登录
      canReceive:-1,
      limitDesc:''
    }
  },

  watch: {},
  created() {
    // this.loadChannels()
  },
  mounted() {
    console.log(this.$route.params,'--this.$route.params--');
    if (this.$store.state.user && this.$store.state.user.token) {
      this.islogin = true
    }
    this.detailid = this.$route.params.detailid;
    if (this.$route.params.detailid === undefined) {
      this.detailid = getItem("detailid")
    }
    setItem('detailid', this.detailid)
    this.onLoad()
  },
  methods: {
    async userinfo() {
      const {
        data
      } = await getuserInfo()
      this.userType = data.data.userType
      // this.finished=true
    },
    async onLoad() {
      let params = {
        storeCouponTypeId: this.detailid
      }
      console.log(params,'详情参数')
      const {
        data
      } = await getCouponInfo(params)
      this.data = data.data
      this.canReceive=data.data.canReceive
      this.limitDesc=this.canReceive===-1?'':(data.data.limitType===0?'因商户原因，'+data.data.enterpriceName+'每日限领 '+data.data.limitNum+' 张':'因商户原因，'+data.data.enterpriceName+'每月限领 '+data.data.limitNum+' 张')
      this.userinfo()
      this.record({
        "type": 3,
        "resourceId": this.data.storeId
      })
    },
    async clickdetial() {
      // 防止重复点击
      if (this.loading) {
        return;
      }
      
      this.loading = true;
      
      try {
        let params = {
          //   "userId":12,
          "busiStoreCouponTypeId": this.detailid,
        }
        if (this.detailid == null) {
          Dialog.alert({
            title: '',
            message: '请重新选择优惠卷',
          }).then(res => {
            this.$router.push({
              name: 'home'
            })
          })
          return;
        }
        const {
          data
        } = await getReceiveCoupon(params)
        if (data.code == '100102' || data.code == '100103' ||
          data.code == '100104' ||
          data.code == '100105') {
          Dialog.alert({
            title: '',
            confirmButtonText: '立即开通',
            message: '您尚未开通会员，无法领取！',
          }).then(() => {
              Dialog.alert({
                message: '当前未开启线上订购业务，敬请期待!',
              })
          });
        }
        else if (data.code == '100106') {
          Dialog.alert({
            title: '',
            confirmButtonText: '确定',
            message: '目前活动仅限山东用户参与，敬请期待！',
          })

        }

        else if (data.code == '200102') {
          Dialog.alert({
            title: '',
            confirmButtonText: '确定',
            message: '尊敬的会员您好，您本月领取资格已用光，可在首页-领取记录中查看本月领取内容。',
          })

        }
        else {
          Dialog.alert({
            title: '',
            confirmButtonText: '确定',
            message: data.msg,
          }).then(()=>{
            let params = {
              storeCouponTypeId: this.detailid
            }
            const {
              data
            } = getCouponInfo(params)
            this.data = data.data
            this.canReceive=data.data.canReceive
            this.limitDesc=this.canReceive===-1?'':(data.data.limitType===0?'因商户原因，'+data.data.enterpriceName+'每日限领 '+data.data.limitNum+' 张':'因商户原因，'+data.data.enterpriceName+'每月限领 '+data.data.limitNum+' 张')
          })
        }
      } catch (error) {
        console.error('请求失败:', error);
        Dialog.alert({
          title: '',
          message: '网络请求失败，请稍后重试',
        });
      } finally {
        this.loading = false;
      }
    }
    // if(data.code == )
    // onUpdateActive(index) {
    //   this.active = index
    // }
  }
}
</script>

<style lang="less">


.van-notice-bar {
  margin-top:20px;
  padding-left: 0.1rem;
  margin-left: 0.23rem;
  border-radius: 0.3rem;
  //width: 8.31rem;
  height: 0.6rem;
  font-size: 0.35rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  background: #ffbb6b;
}
.van-notice-bar__left-icon, .van-notice-bar__right-icon{
  margin-right: 0.2rem;
  color: rgb(41,156,254);
  width: 0.6rem;
  background: #fff;
  border-radius: 0.3rem;
  padding: 0.05rem 0 0.05rem 0.15rem
}

img {
  pointer-events: none;
}

.sc-button {
  background-image: url(../../assets/img/scbutton.png);
  width: 90%;
  margin: 0 auto;
  position: relative;
  bottom: 0.2rem;
  -webkit-transform: translateZ(0);
  background-size: 100% 100%;
  left: 0;
  right: 0;
  color: #FFFFFF;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  font-size: 0.38rem;
  padding: 0.4rem;

}

p {
  margin-bottom: 0.2rem;
}

.sc-text {
  font-size: 0.32rem;
  background: #fff;
  width: 93%;
  margin: 0 auto;
  margin-top: 3rem;
  box-sizing: border-box;
  padding: 0.2rem;
  line-height: 0.5rem;
  border-radius: 0.2rem;
  color: #333333;
}

.sc-step {
  z-index: 999;
  position: absolute;
  // display: flex;
  margin: 0 auto;

  img {
    display: block;
    float: left;
    width: 1.2rem;
    margin: 0.2rem 0.57rem;
  }
}

.sc-step-loop {

  position: absolute;
  width: 89%;
  height: 0.2rem;
  background: #FFE0E5;
  border-radius: 0.5rem;
  width: 86%;
  /* margin: 0px auto; */
  /* bottom: 1.05rem; */
  top: 0.7rem;
  left: 0.7rem;
  z-index: 12;

  span {
    display: block;
    width: 30%;
    height: 100%;
    background: #F12F51;
  }
}

.home-container {
  .sc-tops {
    background-image: url(../../assets/img/sctop.png);
    width: 100%;
    //height: 4.4rem;
    padding-top: 0.5rem;
    background-size: 100% 100%;

    .top-center-count{
      padding: 0.2rem 0 0 0.5rem;
      box-sizing: border-box;
      margin: 0 auto;
      background: #fff;
      width: 93%;
      .count-tip{
        color: rgb(0, 0, 0);
        font-family: 等线;
        font-size: 13.3333px;
        font-weight: bold;
      }
      .highlight {
        font-size: 13.3333px;
        background-color: red;
        color: white;
        padding: 0 2px; /* 可根据需要调整内边距 */
        border-radius: 2px; /* 如果需要圆角 */
     }
    }
    .top-center {
      display: flex;
      padding: 0.5rem;
      box-sizing: border-box;
      margin: 0 auto;
      background: #fff;
      width: 93%;

      img {
        display: block;
        width: 1.8rem;
        height: 2rem;
      }

      .list-info {
        padding-left: 0.5rem;

        span {
          display: block;
          font-size: 0.3rem;

          &:nth-child(1) {

            font-size: 0.4rem;
            color: #333333;
            font-family: SourceHanSansCN-Regular;
          }

          &:nth-child(2) {
            padding: 0.1rem 0;
            font-size: 0.3rem;
            background: #FFE9E9;
            border-radius: 0.48rem;
            text-align: center;
            margin: 0.28rem;
            width: 2.5rem;
            color: #E60027;
            margin-left: 0;

          }

          &:nth-child(3) {
            font-size: 0.3rem;
            color: #999999;
          }
        }

      }

    }
  }
}
</style>
